import React from 'react';
import { GenericListPage } from '../../../components/generic';
import { useCallTypes, CallType } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<CallType>
      useData={useCallTypes}
      config={{
        ...moduleConfig,
        getColumns,
        getToolbarIcon,
        getTableActions,
      }}
    />
  );
};

export default List;
